{
  "attorney": {
    "header": {
      "title": "Anwalts-Dashboard"
    },
    "nav": {
      "filingQueue": "Anmeldewarteschlange",
      "approvalQueue": "Genehmigungswarteschlange",
      "clients": "Meine Mandanten",
      "correspondence": "Korrespondenz",
      "deadlines": "Fristen",
      "jurisdictions": "Zuständigkeiten",
      "assignments": "Zuweisungen verwalten",
      "backToDashboard": "Zurück zum Dashboard"
    },
    "filingQueue": {
      "title": "Anmeldewarteschlange",
      "loading": "Anmeldewarteschlange wird geladen...",
      "error": "Fehler beim Laden der Anmeldewarteschlange",
      "empty": "Keine Anmeldungen in der Warteschlange",
      "allCountries": "Alle Länder",
      "allStatuses": "Alle Status",
      "statusPending": "Ausstehend",
      "statusFiled": "Eingereicht",
      "refresh": "Aktualisieren"
    },
    "filingCard": {
      "allFiled": "Alle eingereicht",
      "partiallyFiled": "In Bearbeitung",
      "pending": "Ausstehend",
      "client": "Mandant",
      "classes": "Klassen",
      "country": "Land",
      "status": "Status",
      "ipOfficeRef": "IP-Amt Ref.",
      "actions": "Aktionen",
      "jurisdictionsFiled": "Zuständigkeiten eingereicht"
    },
    "jurisdiction": {
      "pending": "Ausstehend",
      "filed": "Eingereicht",
      "accepted": "Akzeptiert",
      "registered": "Registriert",
      "rejected": "Abgelehnt",
      "fileNow": "Jetzt einreichen",
      "viewDocs": "Dokumente ansehen",
      "view": "Ansehen",
      "editRef": "Ref. bearbeiten"
    },
    "fileNowModal": {
      "title": "Einreichung in {{country}}",
      "applicationRef": "Anmeldereferenz",
      "useReference": "Verwenden Sie diese Referenz in allen IP-Amt-Formularen:",
      "copy": "Kopieren",
      "copied": "Kopiert!",
      "ipOfficePortal": "IP-Amt Portal",
      "openPortal": "Portal öffnen",
      "instructions": "Anleitung",
      "step1": "Melden Sie sich beim {{office}}-Portal an",
      "step2": "Starten Sie eine neue Markenanmeldung",
      "step3": "Geben Sie \"{{appId}}\" im Feld \"Ihre Referenz\" ein",
      "step4": "Laden Sie das generierte Anmeldedokument hoch",
      "step5": "Schließen Sie die Zahlung beim IP-Amt ab",
      "step6": "Notieren Sie die {{office}}-Referenznummer",
      "documents": "Dokumente",
      "afterFiling": "Nach der Einreichung geben Sie die IP-Amt-Referenznummer ein:",
      "cancel": "Abbrechen",
      "markAsFiled": "Als eingereicht markieren",
      "marking": "Wird markiert..."
    },
    "approvalQueue": {
      "title": "Genehmigungswarteschlange",
      "loading": "Genehmigungswarteschlange wird geladen...",
      "error": "Fehler beim Laden der Genehmigungswarteschlange",
      "empty": "Keine Aufgaben warten auf Genehmigung",
      "allTypes": "Alle Typen",
      "officeAction": "Amtsbescheidantworten",
      "opposition": "Widerspruchsantworten",
      "renewal": "Verlängerungsanträge",
      "refresh": "Aktualisieren"
    },
    "approvalCard": {
      "officeAction": "Amtsbescheidantwort",
      "opposition": "Widerspruchsantwort",
      "renewal": "Verlängerungsantrag",
      "urgent": "Dringend",
      "high": "Hoch",
      "medium": "Mittel",
      "low": "Niedrig",
      "successLikelihood": "Erfolgswahrscheinlichkeit",
      "noSummary": "Keine Zusammenfassung verfügbar",
      "daysLeft": "{{days}} Tage verbleibend",
      "overdue": "Überfällig!",
      "review": "Entwurf prüfen"
    },
    "draftReview": {
      "title": "KI-Entwurf überprüfen",
      "summary": "Zusammenfassung",
      "estimatedSuccess": "Geschätzter Erfolg",
      "keyArguments": "Kernargumente",
      "similarCases": "Referenzierte ähnliche Fälle",
      "draftContent": "Entwurfsinhalt",
      "view": "Ansehen",
      "edit": "Bearbeiten",
      "editPlaceholder": "Entwurf bearbeiten...",
      "rejectReason": "Ablehnungsgrund",
      "rejectPlaceholder": "Erklären Sie, warum dieser Entwurf abgelehnt wird...",
      "back": "Zurück",
      "reject": "Ablehnen",
      "confirmReject": "Ablehnung bestätigen",
      "rejecting": "Wird abgelehnt...",
      "approve": "Genehmigen",
      "approveWithChanges": "Mit Änderungen genehmigen",
      "approving": "Wird genehmigt..."
    }
  }
}
